import { Pipe, PipeTransform } from '@angular/core';
import { Transaction } from '../../schemas/transaction';
import { PaymentAccount } from '../../schemas/payment_account';

@Pipe({
  name: 'transactionAccountFilter',
})
export class TransactionAccountFilterPipe implements PipeTransform {
  transform(
    transactions: Transaction[],
    searchText: string | null,
  ): Transaction[] {
    if (!transactions) return [];
    // console.log('searchText', searchText);
    if (searchText == 'all' || !searchText) return transactions;
    // searchText = searchText.toLowerCase();
    // console.log('transactions', transactions);
    // if (searchText === 'null') {
    //   console.log('searchText', searchText);
    // }

    return transactions.filter((searchItem) => {
      if (searchText === 'null') {
        return searchItem.receiver_account == null;
      }
      return (searchItem.receiver_account as PaymentAccount)?.id == searchText;
    });
  }
}
